export const SET_TRAFFIC_CAMERAS_FROM_SERVER_DATA = 'SET_TRAFFIC_CAMERAS_FROM_SERVER_DATA';
export const RESET_SERVER_TRAFFIC_CAMERA_DATA = 'RESET_SERVER_TRAFFIC_CAMERA_DATA';
export const DID_VERIFY_SERVER_TRAFFIC_CAMERA_DATA = 'DID_VERIFY_SERVER_TRAFFIC_CAMERA_DATA';

export type ServerTrafficCamera = {
    Name: string;
    Disabled: boolean;
    Latitude: number;
    Longitude: number;
    SmallImageUrl: string;
    SmallImageUrlCache: string;
    LargeImageUrl: string;
    LargeImageUrlCache: string;
    JumboImageUrl: string;
    JumboImageUrlCache: string;
    CameraId: number;
    Distance: number;
    Location: null; // always null from server.
}

export type ServerDataPayload = { 
    serverCameras: Array<ServerTrafficCamera>;
    lat: number;
    lng: number;
    city: string;
    state: string;
}

export type SetInitialTrafficCamDataWithServerDataActionType = {
    type: typeof SET_TRAFFIC_CAMERAS_FROM_SERVER_DATA;
    payload: ServerDataPayload;
}

export function setInitialTrafficCamDataWithServerData(payload: ServerDataPayload): SetInitialTrafficCamDataWithServerDataActionType {
    return {
        type: SET_TRAFFIC_CAMERAS_FROM_SERVER_DATA,
        payload: payload
    };
} 

export type ResetServerTrafficCamDataType = {
    type: typeof RESET_SERVER_TRAFFIC_CAMERA_DATA;
    payload?: any;
}
export function resetServerTrafficCamData(): ResetServerTrafficCamDataType {
    return {
        type: RESET_SERVER_TRAFFIC_CAMERA_DATA
    };
} 

export type DidVerifyServerTrafficCamDataType = {
    type: typeof DID_VERIFY_SERVER_TRAFFIC_CAMERA_DATA;
    payload?: any;
}
export function didVerifyServerTrafficCamData(): DidVerifyServerTrafficCamDataType {
    return {
        type: DID_VERIFY_SERVER_TRAFFIC_CAMERA_DATA
    };
} 